import Vue from "vue";
import moment from "moment";
import ApiService from "../../../../../services/api";
import gridbase from "../../../../../components/gridComponentBase.js";
import { mapGetters } from "vuex";
import helpers from "../../../../../shared/fleetbox-helpers";
import { bus } from "../../../../../main";

export default {
	extends: gridbase,
	props: {
		filters: Array
	},
	data: function() {
		return {
			columns: [
				{
					field: "number_plate",
					configId: "number_plate",
					title: "targa",
					width: "100",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_code",
					configId: "vehicle_code",
					title: "codice",
					width: "100",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "driver_name",
					title: "conducente",
					configId: "driver_name",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_name",
					title: "veicolo",
					configId: "vehicle_name",
					width: "290",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "event_date",
					configId: "event_date",
					title: "data",
					width: "150",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "datetime",
					filterable: false,
					sortable: false
				},
				{
					field: "description",
					configId: "description",
					title: "Posizione",
					width: "450",
					headerCell: "myHeaderTemplate",
					format: "",

					filterable: false,
					sortable: false
				},
				{
					field: "position_display_name",
					configId: "location",
					title: "Posizione",
					width: "450",
					headerCell: "myHeaderTemplate",
					format: "",

					filterable: false,
					sortable: false
				},
				{
					field: "speed",
					title: "velocità",
					configId: "speed",
					width: "100",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "numeric",
					filterable: false,
					sortable: false
				},
				{
					field: "latitude",
					configId: "latitude",
					title: "posizione",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "positionCoordinates",
					filterable: false,
					sortable: false
				},
				{
					field: "longitude",
					configId: "longitude",
					title: "posizione",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "positionCoordinates",
					filterable: false,
					sortable: false
				},
				{
					field: "value",
					title: "Valore",
					configId: "value",
					width: "290",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				}
			],

			config: [],
			columnsToShow: [],
			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles",

			canGetValue: false
		};
	},

	created() {
		this.hasSelectedMode = true;
		this.query.pageSize = 2147483647;
		this.take = 2147483647;

		// if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
		// 	this.query.pageSize = parseInt(this.settings.defaultPageSize);
		// 	this.take = parseInt(this.settings.defaultPageSize);
		// }

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
		}
	},
	mounted() {
		this.getConfig();
	},
	watch: {
		// filters: {
		// 	handler: function() {
		// 		this.getData();
		// 	},
		// 	deep: true
		// }
	},
	methods: {
		applyReportFilter() {
			this.getData();
		},
		formattedCoordinates(current_position, typeCoord) {
			if (current_position && current_position.lat && current_position.lon) {
				var tc = typeCoord.substring(0, 3);
				return helpers.formatCoordinate(current_position[tc], tc);
			}
			return null;
		},
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_report_trip_events")
				.then(res => {
					self.config = res;
					self.setConfigColumns();
				})
				.finally(res => {
					self.getData();
				});
		},
		setConfigColumns() {
			var self = this;
			if (self.config && self.config.length > 0) {
				var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

				orderedConfigColumn.forEach(column => {
					var defColumn = self.columns.find(function(f) {
						return f.configId === column.field;
					});

					if (defColumn && column.enabled) {
						defColumn.title = column.label;

						self.columnsToShow.push(defColumn);
					}
				});

				if (self.columnsToShow.length > 0) {
					var columnsByPassConfig = self._.filter(self.columns, function(item) {
						return item.configByPass;
					});

					for (var i = 0; i < columnsByPassConfig.length; i++) {
						self.columnsToShow.push(columnsByPassConfig[i]);
					}
				}

				self.dataReady = true;
			}
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		// pageChangeHandler: function(event) {
		// 	this.skip = event.page.skip;
		// 	this.take = event.page.take;

		// 	if (this.skip === 0) {
		// 		this.query.page = 0;
		// 	}
		// 	this.query.page = this.skip / this.take;

		// 	this.getData();
		// },
		downloadXlsx: function(type) {
			var self = this;
			var data = this.getRequestData();
			if (type == "csv") data["format"] = "csv";
			if (type == "pdf") data["format"] = "pdf";
			ApiService.exportXlsx("report/trips/events", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Report_Allarmi_dettagliato.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			if (this.canGetValue) {
				ApiService.getEventTripsDetailReport(data).then(res => {
					self.items = res.items.map(a => {
						return {
							id: a.id,
							trip_id: a.trip_id,
							event_date: a.event_date,
							box_serial_number: a.box_serial_number,
							number_plate: a.number_plate,
							vehicle_code: a.vehicle_code,
							vehicle_id: a.vehicle_id,
							vehicle_name: a.vehicle_name,
							driver_id: a.driver_id,
							driver_name: a.driver_name,
							division_id: a.division_id,
							type: a.type,
							subtype: a.subtype,
							position_type: a.position_type,
							type_name: a.type_name,
							description: a.description,
							timestamp: a.timestamp,
							mas: a.mas,
							speed: a.speed,
							position: a.position,
							position_display_name: a.position_display_name,
							drive_direction: a.drive_direction,
							value: a.value, //a.data ? a.data.value : "",
							description: a.description //a.data ? a.data.parameter : ""
						};
					});

					self.total = res.totalCount;

					self.$emit("on-loading", false);

					self.setAddress();
				});
			} else {
				self.items = [];
				self.total = 0;

				self.$emit("on-loading", false);
			}
		},
		getRequestData() {
			var self = this;
			var data = {};

			if (this.sort && this.sort.length > 0) {
				var sortParam = "";
				for (var i = 0; i < this.sort.length; i++) {
					if (i > 0) sortParam += ",";

					var fieldAndDir = this.sort[i];
					sortParam += `${fieldAndDir.field}|${fieldAndDir.dir}`;
				}

				data["sort"] = sortParam;
			}

			// if (this.query.page) {
			// 	data["page"] = this.query.page;
			// }

			// if (this.query.pageSize) {
			// 	data["pageSize"] = this.query.pageSize;
			// }
			var hasDateFilter = false;
			var hasVehicleFilter = false;
			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							hasDateFilter = true;
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								var field = `${self.vehicleIdFilterFieldFormatted}[0]`;
								var value = element.value;

								data[field] = value;
								hasVehicleFilter = true;
							}
							break;
						default:
							break;
					}
				});
			}

			this.canGetValue = hasDateFilter && hasVehicleFilter;

			return data;
		},
		setAddress() {
			var self = this;

			var bulkGetAddress = function(data) {
				if (data.length > 0) {
					ApiService.getBulkReverseGeocoding(data).then(resBulk => {
						if (resBulk && resBulk.length > 0) {
							for (var i = 0; i < resBulk.length; i++) {
								var resTrip = resBulk[i];

								var itemToUpdate = self.items.find(item => {
									return item.id == resTrip.id;
								});
								if (itemToUpdate) {
									var res = resTrip.data;
									if (res && res.length > 0) {
										var newAddress = self._.find(res, function(item) {
											return (
												self._.find(item.types, function(x) {
													return x === "streetAddress";
												}) != null
											);
										});

										if (!newAddress) {
											newAddress = res[0];
										}

										var address = "";
										if (newAddress && newAddress.formattedAddress) {
											address = newAddress.formattedAddress;
										}

										itemToUpdate.position_display_name = address;
									}
								}
							}
						}
					});
				}
			};

			var indexStart = 1;
			var dataGetAddressStart = [];

			for (var i = 0; i < self.items.length; i++) {
				var item = self.items[i];
				if ((self._.isNull(item.position_display_name) || item.position_display_name.length == 0) && self._.isNull(item.position) === false) {
					var params = {
						id: item.id,
						type: "trip-event",
						field: "position_display_name",
						latitude: item.position.lat,
						longitude: item.position.lon
					};

					dataGetAddressStart.push(params);

					if (indexStart % 25 == 0) {
						bulkGetAddress(dataGetAddressStart);
						dataGetAddressStart = [];
					}

					indexStart++;
				}
			}

			if (dataGetAddressStart.length > 0) {
				bulkGetAddress(dataGetAddressStart);
			}
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},
	computed: {
		...mapGetters(["settings"])
	}
};
